var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorBgBlob = function SvgErrorBgBlob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 302 868"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#96CE95",
    fillRule: "evenodd",
    d: "M275.195 0h26.768v868h-48.169c-78.035-52.733-147.115-124.861-192.496-212.97-82.265-159.718-86.53-371.905 16.618-505.166C125.112 87.468 195.031 41.964 275.195 0",
    clipRule: "evenodd"
  })));
};
export default SvgErrorBgBlob;